import React, { useMemo, forwardRef } from 'react';
import Image from '@pushpay/image';
import { clsx, createUseStyles } from '@pushpay/styles';
import { memo } from '@pushpay/types';
import { deepEqual } from '@pushpay/utils';
const avatarSize = '2em';
const useStyles = createUseStyles(theme => {
  const availableColors = [theme.colors['palette-blue'], theme.colors['palette-blue-dark-300'], theme.colors['palette-gold'], theme.colors['palette-green'], theme.colors['palette-green-dark-300'], theme.colors['palette-orange'], theme.colors['palette-teal'], theme.colors['palette-purple'], theme.colors['palette-purple-dark-300']];

  const getColor = id => availableColors[Array.from(id.replace(/[-\s]/g, '')).reduce((result, char) => result + parseInt(char, 16), 0) % availableColors.length];

  return {
    root: ({
      id
    }) => ({
      position: 'relative',
      width: avatarSize,
      height: avatarSize,
      borderRadius: '50%',
      fontWeight: 600,
      color: 'white',
      backgroundColor: getColor(id),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }),
    iconImage: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: avatarSize,
      height: avatarSize,
      objectFit: 'cover',
      objectPosition: '50% 50%',
      borderRadius: '50%',
      border: 'none'
    }
  };
});
export const Avatar = memo( /*#__PURE__*/forwardRef(function Avatar(props, ref) {
  const {
    classes: classesProp,
    className: classNameProp,
    imgUrl,
    id,
    name,
    icon,
    'data-pp-at-target': atTarget,
    ...rest
  } = props;
  const classes = useStyles(classesProp, {
    id
  });
  const className = clsx(classes.root, classNameProp);
  const fallbackContent = useMemo(() => {
    if (Array.isArray(name)) return (name[0].trim().charAt(0) + name[1].trim().charAt(0)).toUpperCase();
    const Icon = icon;
    return Icon && /*#__PURE__*/React.createElement(Icon, {
      "data-pp-at-target": `${atTarget}-fallback-icon`
    });
  }, [icon, name]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className,
    ref: ref,
    "data-pp-at-target": atTarget
  }, rest), fallbackContent, imgUrl && /*#__PURE__*/React.createElement(Image, Object.assign({
    width: avatarSize,
    height: avatarSize,
    lazyLoad: true,
    src: imgUrl,
    className: classes.iconImage,
    "data-pp-at-target": `${atTarget}-image`,
    alt: ""
  }, rest)));
}), deepEqual);